import React from "react";
import "./Css/Course.css";
import { getDatabase, get, child, ref, set } from "@firebase/database";
import Navbar from "./Essentials/Navbar";
import { initializeApp } from "firebase/app";
import config from "./CONFIDENTIAL.js";
import Footer from "./Essentials/Footer";

const getStudents = async () => {
  let students = await get(child(ref(getDatabase()), `/Education`));
  if (students.exists())
    return await students.val();
}


const EnrolledStudents = () => {
  const app = initializeApp(config);
  const [data, setData] = React.useState([]);
  getStudents().then(res => {
    setData(res);
    document.querySelector(".loader").style.visibility = 'hidden';
    document.querySelector(".loader").style.width = '0px';
    document.querySelector(".loader").style.height = '0px';
  }).catch(e => {
    alert("Some error occured!!");
  })
  return (
    <>
      <Navbar />
      <div style={{
        overflowX: window.screen.width < 750 ? "scroll" : "unset",
        width: window.screen.width < 750 ? "unset" : "100%"
      }}>
        <center className="loader">
          <img style={{ width: '3%' }} src="spinner/Loader.gif" />
        </center>
        <table style={{
          width: window.screen.width < 750 ? "unset" : "100%",
          fontSize: '1.1rem'
        }} id="student-data">
          <tr>
            <td>Name</td>
            <td>
              {window.screen.width > 900 ? "Course" : "C"}
            </td>
            <td>
              {window.screen.width > 900 ? "Course - ID" : "ID"}
            </td>
            <td>Date</td>
            <td>Fee</td>
            <td>
              {window.screen.width > 900 ? "Lives-In" : "In"}
            </td>
            <td>
              {window.screen.width > 900 ? "Phone" : "No."}
            </td>
            <td>
              {window.screen.width > 900 ? "Status" : "Is"}
            </td>
          </tr>
          {data && data.map((e, idx) => {
            return (
              <tr key={idx}>
                <td>
                  {e.name}
                </td>
                <td>
                  {e.course}
                </td>
                <td>
                  {e.courseID}
                </td>
                <td>
                  {e.enrollDate}
                </td>
                <td>
                  {e.fee}
                </td>
                <td>
                  {e.livesIn}
                </td>
                <td>
                  {e.phone}
                </td>
                <td>
                  {e.status}
                </td>
              </tr>
            );
          })}
        </table>
      </div>
      <Footer />
    </>
  );
};
export default EnrolledStudents;
